import React, { useCallback } from 'react';
import { formatTranslation } from 'intl';
import { useIntl } from 'react-intl';
import { useGalleryContext } from '..';
import { identitySelector } from '../selectors';
import { fileKindService } from 'services/fileService';
import { DrawIcon } from '../icons';
import {
  getFileTypeNotSupportedForGraphicOperationTitle,
  getNoPermissionTitle,
  getPendingConversionPdfTitle,
} from './model';
import { ActionButton } from './actionButton';
import { IssueTranslationKeys } from 'intl/keys';

interface DrawButtonProps {
  setDrawMode: (bool: boolean) => void;
  isMobile: boolean;
  onMenuClose?: () => void;
}

export const DrawButton: React.FC<DrawButtonProps> = ({
  setDrawMode,
  isMobile,
  onMenuClose,
}) => {
  const intl = useIntl();
  const [file] =
    useGalleryContext().useMainDisplayedFile(identitySelector);
  const { preview } = useGalleryContext();

  const DRAW = formatTranslation(intl, IssueTranslationKeys.previewGalleryDrawingLabel,);
  let drawingDisabled = false;
  let drawingDisabledTooltipTitle = DRAW;

  if (preview || !file) {
    drawingDisabled = true;
    drawingDisabledTooltipTitle = getNoPermissionTitle(intl);
  } else if (fileKindService.isPendingConversionPdf(file)) {
    drawingDisabled = true;
    drawingDisabledTooltipTitle = getPendingConversionPdfTitle(intl);
  } else if (
    !fileKindService.isFileImage(file) ||
    !fileKindService.isDrawableExtension(file)
  ) {
    drawingDisabled = true;
    drawingDisabledTooltipTitle =
      getFileTypeNotSupportedForGraphicOperationTitle(intl);
  }

  const onDrawingClick = useCallback(() => {
    if (drawingDisabled) {
      return;
    }
    setDrawMode(true);
    if (onMenuClose) {
      onMenuClose();
    }
  }, [setDrawMode, drawingDisabled, onMenuClose]);

  return (
    <ActionButton
      isMobile={isMobile}
      onClick={onDrawingClick}
      disabled={drawingDisabled}
      tooltipTitle={drawingDisabledTooltipTitle}
      label={DRAW}
      icon={<DrawIcon />}
    />
  );
};
